import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGiftColorful2 = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 22,
	fill: "none",
	viewBox: "0 0 21 22",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 18.4896,
			height: 12.0182,
			x: .924316,
			y: 8.61963,
			fill: "#FFC700",
			rx: 1.25
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#FF5353",
			strokeWidth: 2.1875,
			d: "M8.0398 2.49482L10.4038 6.33601L5.34546 6.399C4.59647 6.40833 3.90277 6.00594 3.539 5.35116C3.41302 5.1244 3.32755 4.87484 3.30931 4.61608C3.10152 1.66847 5.11351 1.26025 6.6923 1.51154C7.26799 1.60317 7.73427 1.99836 8.0398 2.49482Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#FF5353",
			strokeWidth: 2.1875,
			d: "M12.3703 2.48878L9.93488 6.41414H15.0688C15.8168 6.41414 16.5059 6.00865 16.8691 5.35486C16.9964 5.12566 17.0829 4.8733 17.1012 4.61174C17.3069 1.66495 15.2916 1.25951 13.7129 1.51234C13.1403 1.60402 12.676 1.99606 12.3703 2.48878Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 20.3385,
			height: 4.62239,
			y: 4.92188,
			fill: "#FFC700",
			rx: 1.25
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 3.54166,
			height: 15.5599,
			x: 8.39844,
			y: 5,
			fill: "#FF5353",
			stroke: "#FF5353",
			strokeWidth: .15625
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 2.61719,
			height: 18.3333,
			x: 19.3359,
			y: 9.62207,
			fill: "#FF5353",
			stroke: "#FF5353",
			strokeWidth: .15625,
			transform: "rotate(90 19.3359 9.62207)"
		})
	]
});
const ForwardRef = forwardRef(SvgGiftColorful2);
export default ForwardRef;
